import React from 'react';


const Copyright = () => {
    return (
        <div className="copyright">
            <p className="copyrightDate">&copy; 2021 <span className="copyrightCompany">AQUILA</span></p>
        </div>
    );
};

export default Copyright;